import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const homeSchema = {
    '@context': 'https://seeddex.github.io',
    '@type': 'WebPage',
    name: '种子搜索 - 快速找到你需要的资源',
    description: '种子搜索是最高效的BT资源检索工具，帮助用户快速定位磁力链接与种子文件。支持影视、音乐、软件等全类型资源搜索。',
    url: 'https://seeddex.github.io/',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '种子搜索',
      url: 'https://seeddex.github.io/',
    },
  };

  const faqSchema = {
    '@context': 'https://seeddex.github.io',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '种子搜索是什么？',
        acceptedAnswer: { '@type': 'Answer', text: '种子搜索是一个高效的BT资源检索工具，帮助用户快速定位磁力链接与种子文件。我们聚合了海量的DHT网络数据，支持影视、音乐、软件、游戏、电子书等多种资源类型的搜索，为用户提供精准、快速的资源发现服务。' },
      },
      {
        '@type': 'Question',
        name: '如何使用种子搜索查找资源？',
        acceptedAnswer: { '@type': 'Answer', text: '在首页搜索框中输入你想要的资源名称或关键词，点击搜索即可获得相关结果。你可以使用高级筛选功能按文件大小、发布时间、资源类型等维度缩小搜索范围，更快找到目标资源。' },
      },
      {
        '@type': 'Question',
        name: '磁力链接和种子文件有什么区别？',
        acceptedAnswer: { '@type': 'Answer', text: '种子文件需要先下载到本地再用BT客户端打开，而磁力链接是一段以magnet开头的链接，直接复制到BT客户端即可开始下载。磁力链接更方便快捷，不依赖Tracker服务器，通过DHT网络发现资源。' },
      },
      {
        '@type': 'Question',
        name: '种子搜索是完全免费的吗？',
        acceptedAnswer: { '@type': 'Answer', text: '是的，种子搜索对所有用户完全免费开放。我们致力于为互联网用户提供便捷高效的资源检索服务，不收取任何费用。' },
      },
      {
        '@type': 'Question',
        name: '种子搜索支持哪些类型的资源？',
        acceptedAnswer: { '@type': 'Answer', text: '我们支持影视、音乐、软件、游戏、电子书、素材模板、课程教程等多种资源类型的搜索。我们的数据库涵盖数百个资源类别，几乎可以满足你对任何数字资源的需求。' },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="种子搜索 - 快速找到你需要的资源 | 高效的BT磁力链接搜索引擎"
        description="种子搜索是最高效的BT资源检索工具，帮助用户快速定位磁力链接与种子文件。支持影视、音乐、软件等全类型资源搜索，海量数据库实时更新，精准匹配你的每一次种子搜索需求。"
        keywords="种子搜索,BT种子搜索,磁力链接搜索,种子文件下载,BT资源搜索引擎,磁力搜索工具,免费种子搜索网站"
        canonicalUrl="https://seeddex.github.io/"
        schemaJson={{ ...homeSchema, ...faqSchema }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <CategorySection />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}